import {observable, action, computed, runInAction, when} from "mobx";
import {Nota} from "../types";
import {LocalStorage, LastUpdate, SearchStore} from "ocs-search-commons";
import {parseISO, format} from "date-fns";
import {es} from "date-fns/locale";

const urls = {
  'notas': '/api/notas_vw'
  , 'last_update': '/api/last_nota_update_vw'
}

export class AppStore {
  store: LocalStorage<Nota>;

  @observable
  last_update?: Date;

  @observable
  searchResults: Nota[] = [];

  @observable
  fechaInicio?: Date = undefined;

  @observable
  fechaFin?: Date = undefined;

  @observable
  didSearch = false;

  @observable
  notaCount: number = 0;

  constructor(private searchStore: SearchStore<Nota>) {
    this.store = new LocalStorage<Nota>('ocs-notas', 'notas',
      ['proyectos', 'estados', 'tipos_despliegue', 'oposicion', 'acciones_colectivas',
        'afectaciones_ecologicas', 'afectaciones_sociales', 'ts'], this.fetchNotas());

    when(() => this.store.searchCollLoaded && this.searchStore.queryStateLoaded,
      () => {
        if (this.searchStore.selectStates.size > 0) {
          this.doSearch();
        }
        this.last_update = this.store.lastUpdate;
      });

    when(() => this.store.searchCollLoaded,
      () => {
        this.notaCount = this.store.coll!!.count();
      });
  }

  fetchNotas() {
    return Promise.all([
      fetch(urls.last_update)
        .then(res => res.json() as Promise<LastUpdate[]>)
      //  .then((res: LastUpdate[]) => {
      //    const last = res[0];
      //    last.last_update = parseISO(last.last_update);
      //    runInAction(() => {
      //      this.last_update = last.last_update;
      //    });
      //    return res;
      //  })
      ,
      fetch(urls.notas)
        .then(res => res.json() as Promise<Nota[]>)
        .then(res => {
          res.forEach(n => n.ts = parseISO(n.fecha as unknown as string).getTime())
          return res;
        })
    ]);
  }

  @action
  setFechaStart(fechaInicio: Date | null) {
    this.fechaInicio = fechaInicio ? fechaInicio : undefined;
  }

  @action
  setFechaEnd(fechaFin: Date | null) {
    this.fechaFin = fechaFin ? fechaFin : undefined;
  }

  @computed
  get lastUpdate(): string {
    if (this.last_update) {
      return format(this.last_update, "dd 'de' LLLL 'de' yyyy", {locale: es});
    } else {
      return 'Sin información';
    }
  }

  @computed
  get count() {
    return this.notaCount;
  }

  @action
  doSearch() {
    const query = this.searchStore.searchExpression;
    if (this.fechaInicio && !this.fechaFin) {
      query.ts = {"$gte": this.fechaInicio.getTime()};
    } else if (!this.fechaInicio && this.fechaFin) {
      query.ts = {"$lte": this.fechaFin.getTime()};
    } else if (this.fechaInicio && this.fechaFin) {
      query.ts = {"$between": [this.fechaInicio.getTime(), this.fechaFin.getTime()]};
    }

    const results = this.store.query(query).sort((a, b) => b.ts - a.ts);
    this.searchResults = results;
    this.didSearch = true;
  }

  @action
  clearSearch() {
    this.searchStore.clearAllTerms();
    this.didSearch = false;
    this.searchResults = [];
  }
}
